import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@abyss/web/ui/DataTable';
import { useDataTable } from '@abyss/web/hooks/useDataTable';

export const SearchResults = ({
  setDisableContinueButton,
  setSelectedSearchData,
  taxIdValue,
  getPageData,
}) => {
  useEffect(() => {
    setDisableContinueButton(true);
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'servicingProviderName',
      },
      {
        Header: 'Corp. MPIN',
        accessor: 'corporateProviderMpin',
        minWidth: 150,
      },
      {
        Header: 'NPI',
        accessor: 'npi',
        minWidth: 150,
      },
    ],
    []
  );

  const dataTableProps = useDataTable({
    singleSelection: true,
    initialColumns: columns,
    showPagination: true,
    highlightRowOnHover: true,
    minColumnWidth: 90,
    disableResizing: true,
    usePagination: true,
    apiPaginationCall: getPageData,
    disableApiCallOnLoad: true,
  });

  useEffect(() => {
    dataTableProps.reloadTableData();
  }, [taxIdValue]);

  useEffect(() => {
    if (Object.values(dataTableProps.state.selectedRowIds).some(Boolean)) {
      setDisableContinueButton(false);
      setSelectedSearchData(dataTableProps.state.selectedFlatRows[0]?.original);
    }
  }, [dataTableProps]);

  return (
    <DataTable
      title={`Search results for :   ${taxIdValue}`}
      tableState={dataTableProps}
    />
  );
};

SearchResults.propTypes = {
  setDisableContinueButton: PropTypes.func,
  setSelectedSearchData: PropTypes.func,
  taxIdValue: PropTypes.string,
  getPageData: PropTypes.func.isRequired,
};
SearchResults.defaultProps = {
  setDisableContinueButton: () => {},
  setSelectedSearchData: () => {},
  taxIdValue: '',
};
